import React, {useEffect, useMemo} from 'react';
import {useSelector} from "react-redux";
import {FormattedMessage} from "react-intl";
import {post} from "../../../../api";

function WoocommerceAddToCart({plan_id, product}:{
    plan_id: string,
    product:{
        value: string,
        label: string
    }}) {
    const website = useSelector((state:any)=>state.settings.website);
    const email = useSelector((state:any)=>state.settings.email);
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState('')
    const integration = useSelector((state:any)=>state.settings.integration);
    const testForPurchase = ()=>{
        setLoading(true)
        post('https://api-server-3.goaffpro.com/partner/paymentplans/activate/store_purchase',{
            email, integration,
            data:{
            },
            plan_id,
            payment_gateway:'store_purchase',
        }).then((data)=>{
            if(data.success){
                window.location.assign("/")
            }else{
                setError(data.error)
            }
        }).catch((e)=>{
            setError("Network error");
        }).finally(()=>{
            setLoading(false)
        })
    }
    useEffect(() => {
        const i = setInterval(testForPurchase, 5000)
        return ()=>{
            clearInterval(i)
        }
    }, []);
    const url = useMemo(()=>{
        const u = new URL(website.includes("://") ? website : `https://${website}`)
        u.pathname = `/checkout/`
        u.searchParams.set('add-to-cart', product.value)
        u.searchParams.set('clear-cart', 'true')
        u.searchParams.set('quantity', '1')
        return u.href
    },[website, product])
    return (
        <a href={url} rel={"opener"} className={"btn btn-primary"}
           target={"_blank"}
           title={product.label}>
            <FormattedMessage id={"Buy Now"}></FormattedMessage>
        </a>
    );
}

export default WoocommerceAddToCart;
